var _defs, _g, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "share",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_454",
    "data-name": "Rectangle 454",
    width: 16.908,
    height: 15.572,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151",
    transform: "translate(2.155 1.428)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M5.09,9.59A.654.654,0,0,1,4.9,9.561a.592.592,0,0,1-.426-.6,7.885,7.885,0,0,1,6.5-7.074V.7a.692.692,0,0,1,.378-.612A.749.749,0,0,1,12.1.111L17.08,3.2a.683.683,0,0,1,.013,1.164l-4.981,3.25a.746.746,0,0,1-.746.039.693.693,0,0,1-.385-.617V6.108c-.092.008-.181.018-.267.029a7.144,7.144,0,0,0-5.1,3.172.625.625,0,0,1-.524.281M11.9,1.048v1.6l-.393.056A7.208,7.208,0,0,0,5.584,7.857a8.125,8.125,0,0,1,5-2.6c.262-.034.536-.054.839-.063l.475-.015v1.5l4.424-2.886Zm4.676,2.9h0Z",
    transform: "translate(-1.114 1.175)",
    fill: "#b1cb79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M11.368,13.634H1.237A1.216,1.216,0,0,1,0,12.443V2.691A1.216,1.216,0,0,1,1.237,1.5H5.216a.445.445,0,1,1,0,.889H1.237a.309.309,0,0,0-.314.3v9.752a.309.309,0,0,0,.314.3H11.368a.309.309,0,0,0,.314-.3V8.683a.462.462,0,0,1,.922,0v3.76a1.216,1.216,0,0,1-1.237,1.191",
    transform: "translate(0 1.938)",
    fill: "#b1cb79"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_455",
    "data-name": "Rectangle 455",
    width: 20,
    height: 20,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon_share.c09552f1ca3f737c2d0dde0d0dfb3e6a.svg";
export { ForwardRef as ReactComponent };